export default ({ onClick = undefined }) => (
  <svg
    onClick={onClick}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8C16 12.4182 12.4182 16 8 16C3.58178 16 0 12.4182 0 8C0 3.58178 3.58178 0 8 0C12.4182 0 16 3.58178 16 8Z"
      fill="#FFCC4D"
    />
    <path
      d="M9.77856 11.9998C9.77856 13.2278 8.98256 13.3332 8.00078 13.3332C7.01856 13.3332 6.223 13.2278 6.223 11.9998C6.223 10.7727 7.01856 9.33315 8.00078 9.33315C8.98256 9.33315 9.77856 10.7727 9.77856 11.9998ZM13.3341 6.66649C13.279 6.66649 13.223 6.65626 13.1692 6.63449C10.8452 5.70515 9.89278 4.30515 9.85323 4.24604C9.71678 4.0416 9.77189 3.7656 9.97634 3.6296C10.1803 3.4936 10.455 3.54782 10.5919 3.75138C10.6003 3.76338 11.4497 4.98915 13.499 5.80871C13.727 5.90026 13.8381 6.15849 13.747 6.38649C13.6772 6.56071 13.5101 6.66649 13.3341 6.66649ZM2.66745 6.66649C2.491 6.66649 2.32434 6.56071 2.25456 6.38693C2.16345 6.15893 2.27412 5.90026 2.50212 5.80915C4.55189 4.9896 5.40123 3.76382 5.40967 3.75182C5.54656 3.54915 5.82256 3.49538 6.02611 3.63182C6.22923 3.76871 6.28434 4.04293 6.14834 4.24649C6.10878 4.3056 5.15634 5.7056 2.83278 6.63493C2.77856 6.65626 2.72256 6.66649 2.66745 6.66649Z"
      fill="#664500"
    />
    <path
      d="M10.6658 7.11133H12.4436V15.5558L10.6658 15.5353V7.11133ZM3.55469 15.5558L5.33247 15.5353V7.11133H3.55469V15.5558Z"
      fill="#5DADEC"
    />
    <path
      d="M6.6655 7.99962C6.59884 7.99962 6.53084 7.98451 6.46728 7.95296C4.90639 7.17251 3.32506 7.94496 3.3095 7.95296C3.0895 8.06362 2.82284 7.9734 2.71306 7.75429C2.60328 7.53473 2.69217 7.26762 2.91172 7.15785C2.99261 7.11785 4.91084 6.1814 6.86506 7.15785C7.08461 7.26762 7.1735 7.53473 7.06372 7.75429C6.9855 7.90984 6.82861 7.99962 6.6655 7.99962ZM12.8877 7.99962C12.8211 7.99962 12.7531 7.98451 12.6895 7.95296C11.1282 7.17251 9.54728 7.94496 9.53172 7.95296C9.31217 8.06318 9.0455 7.97385 8.93528 7.75429C8.8255 7.53473 8.91439 7.26762 9.13395 7.15785C9.21484 7.11785 11.1344 6.18185 13.0873 7.15785C13.3068 7.26762 13.3957 7.53473 13.2859 7.75429C13.2077 7.90984 13.0508 7.99962 12.8877 7.99962Z"
      fill="#664500"
    />
    <path
      d="M8 16.0004C12.4183 16.0004 16 15.6025 16 15.1115C16 14.6206 12.4183 14.2227 8 14.2227C3.58172 14.2227 0 14.6206 0 15.1115C0 15.6025 3.58172 16.0004 8 16.0004Z"
      fill="#5DADEC"
    />
    <path
      d="M7.99935 12.8891C8.73573 12.8891 9.33268 12.4911 9.33268 12.0002C9.33268 11.5093 8.73573 11.1113 7.99935 11.1113C7.26297 11.1113 6.66602 11.5093 6.66602 12.0002C6.66602 12.4911 7.26297 12.8891 7.99935 12.8891Z"
      fill="#E75A70"
    />
  </svg>
);
